export default [
    //FOR Contract Manager========================================================================
   
    
   
    

    ///DONE  
    //FOR Contract Manager [branch user]========================================================================
    {
        key: "New Contracts",
        status: "New Contracts",
        label: "Submit For Approval",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateContractStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "HOD Pending Contract",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Submit To HOD",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to Your HOD?",
                successMessage: "This Contract has been successfully Submitted to Your HOD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },

        ]

    },
    {
        subject: "contract",
        key: "submittedToHOD",
        label: "This Contract has beend submitted to HOD for approval",
        reject_reason: "",
        actionButtons: [
        ]

    },

    {
        subject: "contract",
        key: "ProcApprovedContract",
        label: "This Contract has been approved by Procurement Team.",
        reject_reason: "",
        actionButtons: [
        ]

    },

    {
        subject: "contract",
        status: "Proc Rejected Contract",
        key: "ProcRejectedContract",
        label: "This Contract has been rejected By Procurement Team!",
        reject_reason: "",
        actionButtons: [
        ]

    },
    {
        subject: "contract",
        key: "HODApprovedContract",
        label: "This Contract has been approved by HOD and is waiting for Procurement Team Approval!",
        reject_reason: "",
        actionButtons: [
        ]

    },
    {
        subject: "contract",
        status: "HOD Rejected Contract",
        key: "HODRejectedContract",
        label: "This Contract has been rejected By HOD!",
        reject_reason: "",
        actionButtons: [
        ]

    },
    //---------------------------------------------------------------------------------------------------------

    //FOR HOD Contract Approver========================================================================

    {
        subject: "contract",
        key: "HOD Pending Contract",
        label: "Evaluate this Contract and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateContractStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "HOD Approved Contract",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve & Submit to Procurement",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",
 
                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this Contract?",
                successMessage: "This Contract has been successfully Approved and sent to Procurement",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updateContractStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "HOD Rejected Contract",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this Contract?",

                buttonLabel: "Reject this Contract",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This Contract has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },
    {
        key: "HOD Approved Contract",
        status: "HOD Approved Contract",
        label: "This Contract has been Approved by HOD and now waiting for Procurement approval.",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "HOD Rejected Contract",
        status: "HOD Rejected Contract",
        label: "This Contract has been Rejected by HOD.",
        reject_reason: "",
        actionButtons: [

        ]
    },
    //------------------------------------------------------------------------------------------
    
    //FOR Contract Approver [PROCUREMENT TEAM]========================================================================

    {
        subject: "contract",
        key: "procPendingApproval",
        label: "Evaluate this Contract and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateContractStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Approved Contract",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve This Contract",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this Contract?",
                successMessage: "This Contract has been successfully Approved",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updateContractStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Proc Rejected Contract",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this Contract?",

                buttonLabel: "Reject this Contract",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This Contract has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },

    {
        key: "Proc Rejected Contract",
        status: "Proc Rejected Contract",
        label: "This Contract has been Rejected by Procurement Team",
        rejectReason: "",
        actionButtons: [

        ]
    },

    {
        key: "Proc Approved Contracts",
        status: "Approved Contract",
        label: "This Contract has been Approved By Procurement Team",
        reject_reason: "",
        actionButtons: [

        ]
    },


    //------------------------------------------------------------------------------------------


]